import { categories } from '@/mocks/categories';

export default function Footer() {
  const col1 = categories.slice(0, 4);
  const col2 = categories.slice(4, 8);
  const col3 = categories.slice(8, 12);
  const col4 = categories.slice(12, 14);

  return (
    <footer className="bg-background-100 pt-16 md:pt-20 pb-8 md:pb-10">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        {/* Navigation Columns */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-14 md:mb-16">
          {[col1, col2, col3].map((col, colIdx) => (
            <div key={colIdx}>
              <h4 className="font-heading text-base font-bold text-foreground-950 mb-4 pb-3 border-b border-background-300/60">
                Categories
              </h4>
              <ul className="space-y-2.5">
                {col.map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Column 4 */}
          <div>
            <h4 className="font-heading text-base font-bold text-foreground-950 mb-4 pb-3 border-b border-background-300/60">
              More
            </h4>
            <ul className="space-y-2.5">
              {col4.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Main Site
                </a>
              </li>
              <li>
                <a
                  href="/kakobuy-spreadsheet-guide"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Guides
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-background-300/60 pt-8 md:pt-10">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            {/* Brand */}
            <div>
              <p className="font-heading text-3xl md:text-4xl font-extrabold text-foreground-950 leading-none">
                Kakobuy
              </p>
              <p className="font-heading text-3xl md:text-4xl font-extrabold text-primary-500 leading-none mt-1">
                Finds Baby
              </p>
              <div className="w-8 h-0.5 bg-primary-400 my-3"></div>
              <p className="text-xs text-foreground-500 max-w-sm leading-relaxed">
                Independent shopping spreadsheet database. Not affiliated with Kakobuy officially.
              </p>
            </div>

            {/* Social + Copyright */}
            <div className="flex flex-col items-start md:items-end gap-4">
              <div className="flex items-center gap-4">
                {['ri-instagram-line', 'ri-twitter-x-line', 'ri-pinterest-line', 'ri-youtube-line'].map((icon) => (
                  <a
                    key={icon}
                    href="#"
                    className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    <i className={`${icon} text-base`}></i>
                  </a>
                ))}
              </div>
              <p className="text-xs text-foreground-500">
                &copy; {new Date().getFullYear()} Kakobuy Finds Baby. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}